import { createSlice } from '@reduxjs/toolkit';
import {
  createAlertThunk,
  fetchUserAlertsThunk,
  updateAlertThunk,
  deleteAlertThunk,
} from './userStockAlerts';

const initialState = {
  alerts: [],
  loading: false,
  error: null,
};

const alertsSlice = createSlice({
  name: 'alerts',
  initialState,
  reducers: {
    resetError: (state) => {
      state.error = null;
    },
    resetState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      // Create Alert
      .addCase(createAlertThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createAlertThunk.fulfilled, (state, action) => {
        state.alerts.push(action.payload);
        state.loading = false;
      })
      .addCase(createAlertThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Fetch User Alerts
      .addCase(fetchUserAlertsThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserAlertsThunk.fulfilled, (state, action) => {
        state.alerts = action.payload;
        state.loading = false;
      })
      .addCase(fetchUserAlertsThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Update Alert
      .addCase(updateAlertThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateAlertThunk.fulfilled, (state, action) => {
        state.alerts = state.alerts.map(alert =>
          alert.id === action.payload.id ? action.payload : alert
        );
        state.loading = false;
      })
      .addCase(updateAlertThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Delete Alert
      .addCase(deleteAlertThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteAlertThunk.fulfilled, (state, action) => {
        state.alerts = state.alerts.filter(alert => alert.id !== action.payload);
        state.loading = false;
      })
      .addCase(deleteAlertThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetError, resetState } = alertsSlice.actions;
export default alertsSlice.reducer;